var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 24.005,
    viewBox: "0 0 23.999 24.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account-menu",
    d: "M-9760,1146a12.016,12.016,0,0,1,12-12,11.918,11.918,0,0,1,8.485,3.517A11.925,11.925,0,0,1-9736,1146a11.921,11.921,0,0,1-3.515,8.485A11.918,11.918,0,0,1-9748,1158,12.015,12.015,0,0,1-9760,1146Zm12,10a9.959,9.959,0,0,0,6.4-2.32A9.01,9.01,0,0,0-9748,1151a8.957,8.957,0,0,0-6.4,2.676A9.955,9.955,0,0,0-9748,1156Zm-10-10a9.955,9.955,0,0,0,2.2,6.251A10.971,10.971,0,0,1-9748,1149a10.99,10.99,0,0,1,7.8,3.251,9.953,9.953,0,0,0,2.2-6.25,10.011,10.011,0,0,0-10-10A10.009,10.009,0,0,0-9758,1146Zm5-3a5,5,0,0,1,5-5,5,5,0,0,1,5,5,5,5,0,0,1-5,5A5,5,0,0,1-9753,1143Zm2,0a3,3,0,0,0,3,3,3,3,0,0,0,3-3,3,3,0,0,0-3-3A3,3,0,0,0-9751,1143Z",
    transform: "translate(9760 -1133.999)",
    fill: "#233155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenu);
export default __webpack_public_path__ + "static/media/account-menu.bcf6424446495b65956f5f07dbfe1a34.svg";
export { ForwardRef as ReactComponent };